<template>
  <div class="footer">
    <footer>©{{ logo_name }} Technology. All Rights Reserved.</footer>
    <!-- <footer>https://www.hunt-love.com/ belongs to PROMETHEUS HIGH TECHNOLOGY PTE. LTD.</footer> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      logo_name: "",
    };
  },
  created() {
    this.renderUI();
  },
  methods: {
    renderUI() {
      const config = this.$store.state.data;
      this.logo_name = config.logo_name;
    },
  },
};
</script>

<style lang="less" scoped>
footer {
  // position: fixed;
  height: 93px;
  // bottom: 0px;
  width: 100%;
  background: #ffffff;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #797979;
  line-height: 93px;
  letter-spacing: 1px;
}
</style>
